// src/pages/ProfilePage.jsx
import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../utils/firebase';

const ProfilePage = () => {
  const { user, openAuthModal, setAuthMode } = useApp();
  // const navigate = useNavigate();
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({});

  if (!user) {
    return (
      <div className="max-w-2xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-light tracking-tight text-gray-900 mb-4">Sign In Required</h2>
          <p className="text-gray-600 mb-8 max-w-md mx-auto">
            Please sign in to access your profile.
          </p>
          <button 
            onClick={() => {
              setAuthMode('login');
              openAuthModal('buyer');
            }}
            className="bg-black text-white px-8 py-3 rounded-full hover:bg-gray-800 transition-colors duration-200 font-medium"
          >
            Sign In
          </button>
        </div>
      </div>
    );
  }

  // 초기 데이터 설정
  if (!editing && Object.keys(formData).length === 0) {
    setFormData({
      firstName: user.firstName || '',
      lastName: user.lastName || '',
      email: user.email || '',
      phone: user.phone || '',
      address: user.address || '',
      city: user.city || '',
      province: user.province || '',
      postalCode: user.postalCode || '',
      company: user.company || '',
      businessRegistration: user.businessRegistration || ''
    });
  }

  const handleSave = async () => {
    try {
      await updateDoc(doc(db, 'users', user.uid), formData);
      setEditing(false);
      alert('Profile updated successfully!');
    } catch (error) {
      console.error('Error updating profile:', error);
      alert('Failed to update profile');
    }
  };

  const renderField = (label, key, type = 'text') => (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">{label}</label>
      {editing ? (
        <input
          type={type}
          value={formData[key] || ''}
          onChange={(e) => setFormData(prev => ({ ...prev, [key]: e.target.value }))}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        />
      ) : (
        <div className="text-gray-900">{formData[key] || '-'}</div>
      )}
    </div>
  );

  return (
    <div className="max-w-2xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-4xl font-light tracking-tight text-gray-900">Profile</h1>
        {!editing ? (
          <button
            onClick={() => setEditing(true)}
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
          >
            Edit Profile
          </button>
        ) : (
          <div className="space-x-2">
            <button
              onClick={handleSave}
              className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700"
            >
              Save
            </button>
            <button
              onClick={() => setEditing(false)}
              className="bg-gray-600 text-white px-4 py-2 rounded-lg hover:bg-gray-700"
            >
              Cancel
            </button>
          </div>
        )}
      </div>

      <div className="space-y-6">
        {/* Personal Info */}
        <div>
          <h2 className="text-lg font-medium text-gray-900 mb-3">Personal Information</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {renderField('First Name', 'firstName')}
            {renderField('Last Name', 'lastName')}
            {renderField('Email', 'email')}
            {renderField('Phone', 'phone', 'tel')}
          </div>
        </div>

        {/* Address */}
        <div>
          <h2 className="text-lg font-medium text-gray-900 mb-3">Address</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {renderField('Address', 'address')}
            {renderField('City', 'city')}
            {renderField('Province', 'province')}
            {renderField('Postal Code', 'postalCode')}
          </div>
        </div>

        {/* Business Info (if seller) */}
        {user.userType === 'seller' && (
          <div>
            <h2 className="text-lg font-medium text-gray-900 mb-3">Business Information</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {renderField('Company', 'company')}
              {renderField('Business Registration', 'businessRegistration')}
            </div>
          </div>
        )}

        {/* Account Type */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Account Type</label>
          <div className="text-gray-900">
            {user.userType === 'seller' ? 'Seller' : 'Buyer'}
            {user.status === 'pending' && user.userType === 'seller' && (
              <span className="ml-2 px-2 py-0.5 bg-yellow-100 text-yellow-800 text-xs rounded-full">
                Pending Approval
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;